import React from 'react';
import { Star } from 'lucide-react';
const TestimonialCard = ({
  quote,
  author,
  location
}) => {
  return <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-185">
      <div className="flex mb-4" data-id="element-186">
        {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-[#daa520] fill-[#daa520]" data-id="element-187" />)}
      </div>
      <p className="text-[#3a3a3a] italic mb-4" data-id="element-188">"{quote}"</p>
      <p className="text-sm font-medium text-[#5a5a5a]" data-id="element-189">
        {author}, <span className="text-[#b76e79]" data-id="element-190">{location}</span>
      </p>
    </div>;
};
const Testimonials = () => {
  const testimonials = [{
    quote: 'Probé la mascarilla de avena y miel y en serio me quitó las manchas. Me encanta que todo es súper realista.',
    author: 'Valentina R.',
    location: 'Chile'
  }, {
    quote: 'Por fin una guía que piensa en la piel latina. Ahora sé qué productos comprar sin gastar tanto.',
    author: 'Carolina T.',
    location: 'Perú'
  }, {
    quote: 'La rutina de maquillaje rápido me salvó. Tardo 6 minutos y me siento hermosa.',
    author: 'Alicia G.',
    location: 'México'
  }];
  return <section className="w-full py-16 md:py-24 bg-[#faf7f2]" data-id="element-191">
      <div className="container mx-auto px-4" data-id="element-192">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-193">
          <h2 className="text-3xl font-serif font-medium text-[#3a3a3a] mb-4" data-id="element-194">
            Lo que dicen nuestras lectoras
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-195">
            Mujeres reales que ya están disfrutando de los beneficios
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-196">
          {testimonials.map((testimonial, index) => <TestimonialCard key={index} {...testimonial} data-id="element-197" />)}
        </div>
        <div className="mt-16 text-center" data-id="element-198">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eUyRcqtjapHVqi6LGzbfyS/Sonrisa_y_Belleza_en_Casa.png" alt="Belleza Latina Testimonial" className="w-24 h-24 object-cover rounded-full mx-auto mb-4 border-4 border-[#f8e9e6]" data-id="element-199" />
          <p className="text-lg italic text-[#3a3a3a] max-w-2xl mx-auto mb-4" data-id="element-200">
            "Después de años buscando productos caros que no funcionaban para mi
            piel latina, por fin encontré soluciones reales que puedo hacer en
            casa. ¡Mi piel nunca se ha visto mejor!"
          </p>
          <p className="text-sm font-medium text-[#5a5a5a]" data-id="element-201">
            María J., <span className="text-[#b76e79]" data-id="element-202">Colombia</span>
          </p>
        </div>
      </div>
    </section>;
};
export default Testimonials;